/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from "react";
import Dropdown from "../../components/Dropdown";
import TextArea from "../../components/TextArea";
import InputBox from "../../components/InputBox";
import { Link } from "react-router-dom";
import { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GlobalContext from "../../components/Context/GloablContext";
import { motion } from "framer-motion";
import { useEffect } from "react";
import TopHeader from "../../components/TopHeader";
import { useSelector, useDispatch } from "react-redux";
import DropdownWithSearch from "../../components/DropdownWithSearch";
import { validateEmail } from "../../CommonMethods/EmailValidator";
import ErrorMessage from "../../components/ErrorMessage";
import { useAddOrganizationMutation } from "../../features/organizationSlice";
import Loader from "../../components/Loader";
import AnimatedModel from "../../components/Animation/AnimatedModel";
import ConfirmationPrompt from "../../components/ConfirmationPrompt";
import DropdownSearchForMonitor from "./DropdownsWithSearch/dropdownSearchForMonitor";
import PhoneNumberValidator from "../../components/PhoneNumberInput";
import { phoneCodeArray } from "../../CommonMethods/phoneNumberCountryCodes";
import HelpGuideModal from "../../components/HelpGuideModal";
import { useGetHelpGuideAdminQuery } from "../../features/patientSlice";
import DropdownSearchForProvider from "./DropdownsWithSearch/dropdownWithSearchForProvider";

export default function AddOrganizations() {
    const country_code = useSelector(
        (state) =>
            state?.systemConfigData?.globalVariables?.country_code?.split("-")[0]
    );
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    console.log('AddOrganization - location.state:', location.state);
    console.log('AddOrganization - location.search:', location.search);
    console.log('AddOrganization - location.pathname:', location.pathname);

    const userArr = useSelector(
        (state) => state?.userSelect?.selectedUsers?.checkedArr
    );
    const dataArr = useSelector(
        (state) => state?.userSelect?.selectedUsers?.data
    );
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState("");
    const userType =
        localStorage?.getItem("user_type") !== null
            ? localStorage.getItem("user_type")
            : sessionStorage.getItem("user_type");

    const { data: helpguidedata, status: helpguidestatus } =
        useGetHelpGuideAdminQuery(queryParamsadmin, {
            skip: !triggerApiCall, // Skip the query until the trigger is set to true
        });

    const monitorArr = useSelector(
        (state) => state?.monitorsSelect?.selectedUsers?.checkedArr
    );
    const monitorDataArr = useSelector(
        (state) => state?.monitorsSelect?.selectedUsers?.data
    );
    const providerDataArr = useSelector(
        (state) => state?.providersSelect?.selectedUsers?.data
    );
    const providerArr = useSelector(
        (state) => state.providersSelect?.selectedUsers?.checkedArr
    );
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({
        main_number: true,
    });
    const {
        confirmationStateCancel,
        setConfirmationStateCancel,
        confirmationState,
        setConfirmationState,
        setToastmessage,
        toastErrorMessage,
        setToastErrorMessage,
    } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);
    const [emptyField, setEmptyField] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [submitSelected, setSubmitSeletected] = useState(false);
    const [addOrganization] = useAddOrganizationMutation();
    const [isDisableCancel, setIsDisableCancel] = useState(true);
    const [orgDetails, setOrgDetails] = useState({
        org_name: "",
        main_number: "",
        address: "",
        value_added: true,
        direct_billing: true,
    });
    const [countryCodeVal, setCountryCodeVal] = useState("");

    const [newSubDiv, setNewSubDiv] = useState([
        {
            sub_div_name: "",
            no_of_minutes: "",
            no_of_time_period: "",
            time_period: "Day(s)",
            no_of_readings: "",
            no_of_time_period2: "",
            time_period2: "Day(s)",
            name: "",
            email_addr: "",
            main_number: "",
            mobile_number: "",
        },
    ]);
    const [newSubDivCountycodes, setNewSubDivCountrycodes] = useState([
        {
            mobile_number: country_code?.split("\t").join(""),
            poc_main_number: country_code?.split("\t").join(""),
        },
    ]);
    const [newSubValidCountrycode, setNewSubValidCountrycode] = useState([
        {
            mobile_number: true,
            poc_main_number: true,
        },
    ]);

    // const handleRemoveSubDiv = (indexToRemove) => {

    //     if(newSubDiv?.length==1){
    //         setToastErrorMessage('At least one sub division is required')
    //         return
    //     }
    //     dispatch(popArray([indexToRemove]))
    //     dispatch(popFromMonitorArray([indexToRemove]))
    //     dispatch(popFromProviderArray([indexToRemove]))
    //     const updatedOrgFields = newSubDiv.filter((_, index) => index !== indexToRemove);
    //     const updatedCoun_fields=newSubDivCountycodes.filter((_, index)=>index!==indexToRemove)
    //     const updatedPhoneValidations=newSubValidCountrycode.filter((_,index)=>index!==indexToRemove)
    //     setNewSubValidCountrycode(updatedPhoneValidations)
    //     setNewSubDiv(updatedOrgFields);
    //     setNewSubDivCountrycodes(updatedCoun_fields)
    // };

    // const handleAddSubDiv = () => {
    //     setIsDisableCancel(false)
    //     dispatch(pushArray())
    //     dispatch(pushToMonitorArray())
    //     dispatch(pushToProviderArray())
    //     const updatedNewSubDiv = [
    //         { sub_div_name: '',
    //             no_of_minutes:'',no_of_time_period:'',time_period:'',
    //             no_of_readings:'',no_of_time_period2:'',time_period2:'',
    //             name:'',email_addr:'',main_number:'',mobile_number:''
    //         },
    //         ...newSubDiv,

    //     ];
    //     const updatedNewCountry_code =[
    //         {
    //             mobile_number:country_code.split('\t').join(''),
    //             poc_main_number:country_code.split('\t').join('')
    //         },...newSubDivCountycodes
    //     ]
    //     setNewSubDiv(updatedNewSubDiv);
    //     const updatedPhoneValidCodes=[
    //         {
    //             mobile_number:true,
    //             main_number:true
    //         },...newSubValidCountrycode
    //     ]
    //     setNewSubValidCountrycode(updatedPhoneValidCodes)
    //     setNewSubDivCountrycodes(updatedNewCountry_code)

    // };

    function handleOnChangeOrgDetails(id, option) {
        setIsDisableCancel(false);
        setSubmitSeletected(false);

        // setPocError(false)
        setEmailError(false);
        setEmptyField(false);
        const fieldToUpdate = {
            organization_name: "org_name",
            main_number: "main_number",
            address: "address",
            value_added: "value_added",
            direct_billing: "direct_billing",
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid = true;
        if (id === "main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid = false;
            }
        }
        if (!isValid) {
            if (fieldToUpdate) {
                setOrgDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption,
                }));
            }
            return;
        }
        if (fieldToUpdate) {
            setIsDisableCancel(false);
            if (
                fieldToUpdate === "value_added" ||
                fieldToUpdate === "direct_billing"
            ) {
                setOrgDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: !option,
                }));
            } else if (fieldToUpdate === "main_number") {
                if (option?.length <= 20) {
                    setOrgDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            } else if (fieldToUpdate === "org_name") {
                if (option?.length <= 75) {
                    setOrgDetails((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            } else {
                setOrgDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }
        }
    }

    const handleOnChangeSubDivDetails = (id, option, index) => {
        // setPocError(false)
        setEmailError(false);
        setEmptyField(false);
        setSubmitSeletected(false);
        const fieldToUpdate = {
            sub_div_name: "sub_div_name",
            no_of_minutes: "no_of_minutes",
            no_of_time_period: "no_of_time_period",
            time_period: "time_period",
            no_of_readings: "no_of_readings",
            no_of_time_period2: "no_of_time_period2",
            time_period2: "time_period2",
            name: "name",
            email_addr: "email_addr",
            poc_main_number: "main_number",
            main_number: "main_number",
            mobile_number: "mobile_number",
        }[id];

        const updatedNewSubDiv = [...newSubDiv];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid = true;
        if (
            id === "poc_main_number" ||
            id === "mobile_number" ||
            id === "no_of_minutes" ||
            id === "no_of_time_period" ||
            id === "no_of_readings" ||
            id === "no_of_time_period2"
        ) {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid = false;
            }
        }
        if (!isValid) {
            if (fieldToUpdate) {
                updatedNewSubDiv[index][fieldToUpdate] = sanitizedOption;
                setNewSubDiv(updatedNewSubDiv);
                return;
            }
        }
        if (fieldToUpdate) {
            setIsDisableCancel(false);
            if (
                fieldToUpdate === "main_number" ||
                fieldToUpdate === "mobile_number" ||
                id === "no_of_minutes" ||
                id === "no_of_time_period" ||
                id === "no_of_readings" ||
                id === "no_of_time_period2"
            ) {
                if (option?.length <= 20) {
                    updatedNewSubDiv[index][fieldToUpdate] = option;
                }
            } else if (fieldToUpdate === "sub_div_name") {
                if (option?.length <= 75) {
                    updatedNewSubDiv[index][fieldToUpdate] = option;
                }
            } else if (fieldToUpdate === "email_addr") {
                if (option?.length <= 80) {
                    updatedNewSubDiv[index][fieldToUpdate] = option.replace(/\s/g, "");
                }
            } else {
                updatedNewSubDiv[index][fieldToUpdate] = option;
            }
        }
        setNewSubDiv(updatedNewSubDiv);
    };
    const handleCOuntryCodeForObj = (index, item, id) => {
        const updatedCOuntryCodes = [...newSubDivCountycodes];
        updatedCOuntryCodes[index][id] = item.split("-")[0].trim();
        setNewSubDivCountrycodes(updatedCOuntryCodes);
    };
    const handlePhoneLayerValidation = (index, valid, id) => {
        const updatedIsValids = [...newSubValidCountrycode];
        updatedIsValids[index][id] = valid;
        setNewSubValidCountrycode(updatedIsValids);
    };
    function handleSubmit() {
        setSubmitSeletected(true);
        const hasEmptyFields = () => {
            const areFieldsEmpty = newSubDiv.some(
                (field) => field.sub_div_name.trim() === ""
            );
            return (
                areFieldsEmpty ||
                orgDetails.org_name.trim() === "" ||
                orgDetails.main_number === ""
            );
        };
        if (hasEmptyFields()) {
            setLoading(false);
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        function isEmailValid() {
            const isValidEmail = newSubDiv.some(
                (field) =>
                    field.email_addr.trim() !== "" &&
                    validateEmail(field.email_addr) === true
            );

            return isValidEmail;
        }
        if (isEmailValid()) {
            setEmailError(true);
            setToastErrorMessage("Please enter valid details");
            setLoading(false);
            return;
        }
        function isphoneNumberValid() {
            const isValidPhone =
                newSubValidCountrycode.some(
                    (field) =>
                        field.poc_main_number === false || field.mobile_number === false
                ) || !isPhoneNumberValid.main_number;

            return isValidPhone;
        }
        if (isphoneNumberValid()) {
            setLoading(false);
            return;
        }

        setConfirmationState(true);
    }

    const handleOnAddOrganization = async () => {
        try {
            setLoading(true);

            // let corporateUsersKey = null;
            // let corporateUsersValue = null;

            // if (isCheckedCorpUsers) {
            //     corporateUsersKey = "selected_corporate_users";
            //     corporateUsersValue = "all";
            // } else if (selectedCorpUsers.length === 0 && unselectedCorpUsers.length === 0 && !isCheckedCorpUsers) {
            //     corporateUsersKey = "selected_corporate_users";
            //     corporateUsersValue = [""];
            // } else if (selectedCorpUsers.length === 0 && unselectedCorpUsers.length > 0) {
            //     corporateUsersKey = "unselected_corporate_users";
            //     corporateUsersValue = unselectedCorpUsers;
            // } else if (unselectedCorpUsers.length === 0 && selectedCorpUsers.length > 0) {
            //     corporateUsersKey = "selected_corporate_users";
            //     corporateUsersValue = selectedCorpUsers;
            // } else if (selectedCorpUsers.length < unselectedCorpUsers.length) {
            //     corporateUsersKey = "selected_corporate_users";
            //     corporateUsersValue = selectedCorpUsers;
            // } else if (selectedCorpUsers.length >= unselectedCorpUsers.length) {
            //     corporateUsersKey = "unselected_corporate_users";
            //     corporateUsersValue = unselectedCorpUsers;
            // }

            const transformedData = newSubDiv.map((sub_div, index) =>
                sub_div.name.trim() === "" &&
                    sub_div.mobile_number === "" &&
                    sub_div.email_addr.trim() === "" &&
                    sub_div.main_number === ""
                    ? {
                        name: sub_div.sub_div_name.trim(),
                        // ...(corporateUsersKey && { [corporateUsersKey]: corporateUsersValue }),
                        monitor_user_list:
                            monitorArr[index][0] === null ? [] : monitorArr[index],
                        corporate_users: userArr[index][0] === null ? [] : userArr[index],
                        provider_list:
                            providerArr[index][0] === null ? [] : providerArr[index],
                        point_of_contact_person: {
                            name: "",
                            poc_mobile_country_code:
                                "+" + newSubDivCountycodes[index].mobile_number?.trim(),
                            mobile_number: "",
                            email_address: "",
                            poc_main_country_code:
                                "+" + newSubDivCountycodes[index].poc_main_number?.trim(),
                            main_number: "",
                        },
                        wellness_timing: {
                            number_of_minutes: parseInt(sub_div.no_of_minutes),
                            number_of_time_periods: parseInt(sub_div.no_of_time_period),
                            time_period: sub_div.time_period,
                        },
                        vital_collection_timing: {
                            number_of_readings: parseInt(sub_div.no_of_readings),
                            number_of_time_periods: parseInt(sub_div.no_of_time_period2),
                            time_period: sub_div.time_period2,
                        },
                    }
                    : {
                        name: sub_div.sub_div_name,
                        // ...(corporateUsersKey && { [corporateUsersKey]: corporateUsersValue }),
                        monitor_user_list:
                            monitorArr[index][0] === null ? [] : monitorArr[index],
                        corporate_users: userArr[index][0] === null ? [] : userArr[index],
                        provider_list:
                            providerArr[index][0] === null ? [] : providerArr[index],
                        point_of_contact_person: {
                            name: sub_div.name,
                            poc_mobile_country_code:
                                "+" + newSubDivCountycodes[index]?.mobile_number?.trim(),
                            mobile_number: sub_div?.mobile_number,
                            email_address: sub_div?.email_addr,
                            poc_main_country_code:
                                "+" + newSubDivCountycodes[index]?.poc_main_number?.trim(),
                            main_number: sub_div?.main_number,
                        },
                        wellness_timing: {
                            number_of_minutes: parseInt(sub_div.no_of_minutes),
                            number_of_time_periods: parseInt(sub_div.no_of_time_period),
                            time_period: sub_div.time_period,
                        },
                        vital_collection_timing: {
                            number_of_readings: parseInt(sub_div.no_of_readings),
                            number_of_time_periods: parseInt(sub_div.no_of_time_period2),
                            time_period: sub_div.time_period2,
                        },
                    }
            );
            let body = {
                organization_name: orgDetails.org_name.trim(),
                organization_address: orgDetails.address,
                organization_main_country_code:
                    "+" +
                    (countryCodeVal === ""
                        ? country_code.split("\t").join("")?.trim()
                        : countryCodeVal.split("\t").join("")?.trim()),
                main_number: orgDetails.main_number,
                sub_divisions: transformedData,
                value_added: orgDetails.value_added,
                direct_billing: orgDetails.direct_billing,
            };
            const addRes = await addOrganization({ body });
            if (addRes?.data?.error?.data?.message) {
                setConfirmationState(false);
                setToastErrorMessage(addRes?.error?.data?.message);
                setLoading(false);
            } else {
                setConfirmationState(false);
                // Update the state to set page_number to 1 for the newly added organization
                const updatedState = {
                    ...location.state,
                    page_number: '1'
                };
                console.log('Original state:', location.state);
                console.log('Updated state with page_number=1:', updatedState);
                navigate(`/manage-organizations/${addRes?.data?.organization_id}`, {
                    state: updatedState,
                });
                setToastmessage(addRes?.data?.message);
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (userType === "corporate-user") {
            setQueryParamsadmin("type=admin-add-organization");
        } else {
            setQueryParamsadmin("type=admin-add-organization");
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true); // Allow the query to run
        }
    }, [queryParamsadmin]);

    // from here states and other related to dropdown

    const handlePlaceHolder = (Username) => {
        let displayNumber = "";
        if (Username === "corporate") {
            if (suggestions.trim() === "") {
                if (
                    (!isSelectAllChecked && selectedCorpUsers[0] === "empty") ||
                    totalCorpUsers === 0
                ) {
                    return `Select Corporate Users`;
                }
                if (
                    isCheckedCorpUsers &&
                    unselectedCorpUsers?.length == 0 &&
                    selectedCorpUsers?.length === 0
                ) {
                    displayNumber = totalCorpUsers;
                    return `${displayNumber} Selected`;
                } else if (
                    !isCheckedCorpUsers &&
                    suggestions.trim() === "" &&
                    selectedCorpUsers.length === 0 &&
                    unselectedCorpUsers.length === 0
                ) {
                    return `Select Corporate Users`;
                } else if (
                    isSelectAllChecked &&
                    (unselectedCorpUsers?.length > 0 || selectedCorpUsers?.length > 0)
                ) {
                    return `${totalCorpUsers - unselectedCorpUsers.length} Selected`;
                } else if (
                    !isSelectAllChecked &&
                    (unselectedCorpUsers?.length > 0 || selectedCorpUsers?.length > 0)
                ) {
                    return `${selectedCorpUsers?.length} Selected`;
                }
            } else {
                if (!isSelectAllChecked && selectedCorpUsers[0] === "empty") {
                    return `Select Corporate Users`;
                }

                if (isSelectAllChecked) {
                    return `${totalCorpUsers - unselectedCorpUsers.length} Selected`;
                } else if (!isSelectAllChecked) {
                    return `${selectedCorpUsers?.length} Selected`;
                }
            }
        }
        // else if(Username === "username") {
        //     if(usersuggestions.trim()===''){
        //         if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'||(totalUsers===0)){
        //             return `Select user name`
        //         }
        //         if(isCheckedUsers&&(unselectedUserNames?.length==0&&selectedUserNames?.length===0)){
        //             return `${totalUsers} Selected`
        //         }else if(!isCheckedUsers&&usersuggestions.trim()===''&&(selectedUserNames.length===0&&unselectedUserNames.length===0)){
        //             return `Select user name`
        //         }else if(isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
        //             return `${totalUsers-unselectedUserNames.length} Selected`
        //         }else if(!isSelectAllUsersChecked&&(unselectedUserNames?.length>0||selectedUserNames?.length>0)){
        //             return `${selectedUserNames?.length} Selected`
        //         }
        //     }else{
        //         if(!isSelectAllUsersChecked&&selectedUserNames[0]==='empty'){
        //             return `Select user name`
        //         }
        //         if(isSelectAllUsersChecked){
        //             return `${totalUsers-unselectedUserNames.length} Selected`
        //         }else if(!isSelectAllUsersChecked){
        //             return `${selectedUserNames?.length} Selected`
        //         }

        //     }
        // }
        // else {
        //     if(orgsuggestions.trim()===''){
        //         if(!isSelectAllOrgChecked&&selectedOrgNames[0]==='empty'||totalOrganization===0){
        //             return `Select organization name`
        //         }
        //         if(isCheckedOrg&&(unselectedOrgNames?.length==0&&selectedOrgNames?.length===0)){
        //             return `${totalOrganization} Selected`
        //         }else if(!isCheckedOrg&&orgsuggestions.trim()===''&&(selectedOrgNames?.length===0&&unselectedOrgNames?.length===0)){
        //             return `Select organization name`
        //         }else if(isSelectAllOrgChecked&&(unselectedOrgNames?.length>0||selectedOrgNames?.length>0)){
        //             return `${totalOrganization-unselectedOrgNames.length} Selected`
        //         }else if(!isSelectAllOrgChecked&&(unselectedOrgNames?.length>0||selectedOrgNames?.length>0)){
        //             return `${selectedOrgNames?.length} Selected`
        //         }
        //     }else{
        //         if(!isSelectAllOrgChecked&&selectedOrgNames[0]==='empty'){
        //             return `Select organization name`
        //         }
        //         if(isSelectAllOrgChecked){
        //             return `${totalOrganization-unselectedOrgNames?.length} Selected`
        //         }else if(!isSelectAllOrgChecked){
        //             return `${selectedOrgNames?.length} Selected`
        //         }

        //     }
        // }
    };

    return (
        <>
            <div className="bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full">
                <TopHeader title={"Manage Organizations"} />
                {/* {((edit&&isFetching&&status!=="fulfilled")||loadingStatus)?<CustomOverLay Active text="Loading Admin/Corporate Details..." classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:<> */}
                <div className="bg-white rounded-lg pb-3 pt-5 pl-[30px] pr-[10px] h-customh3">
                    <motion.div
                        className="mt-1"
                        animate={{ x: 0 }}
                        initial={{ x: -10 }}
                        transition={{ duration: 0.5 }}
                        div
                    >
                        <div className="bg-white">
                            <div className="pr-7">
                                <div className="flex items-center mb-5">
                                    <Link to="/manage-organizations" state={Array.isArray(location.state) ? '' : location.state}>
                                        <h1 className="text-sm font-normal text-[#52555D]">
                                            List of Organizations
                                        </h1>
                                    </Link>
                                    <span className="mx-2">
                                        <img src="/images/breadcrumb-icon.svg" alt="icon" />
                                    </span>
                                    <h1 className="text-sm font-normal text-[#008586]">{`Add Organization`}</h1>
                                    {userType !== "super-admin" && (
                                        <span
                                            onClick={() => setHelpGuideModel(true)}
                                            className="ml-auto min-w-fit cursor-pointer"
                                        >
                                            <img
                                                src="/images/helpguideicon.png"
                                                alt="icon"
                                                loading="lazy"
                                                decoding="async"
                                            />
                                        </span>
                                    )}
                                </div>

                                <div
                                    onClick={() =>
                                        !isDisableCancel
                                            ? setConfirmationStateCancel(true)
                                            : navigate("/manage-organizations", { state: location.state })
                                    }
                                    className="flex cursor-pointer items-center"
                                >
                                    <span>
                                        <img src="/images/back_button_Green.svg" alt="icon" />
                                    </span>
                                    <span className="text-sm font-normal text-[#008586] ml-3">
                                        Go back to Listing
                                    </span>
                                </div>
                                <h1 className="text-xl font-normal text-[#000000] w-full text-center mt-[-23px]">
                                    Add Organization
                                </h1>
                                <p className="text-end pt-3.5 pb-1">
                                    ‘*’ Indicates mandatory field
                                </p>
                            </div>
                            <div
                                className={`pr-5 h-customh15 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}
                            >
                                <div className="rounded-lg px-6 2xl:px-[57px] py-6 mb-4">
                                    <div className="xl:w-[90%] w-[95%]">
                                        <div className="flex flex-wrap -mx-[18px]">
                                            <div className={`w-2/3 px-[18px] mb-6`}>
                                                <div className="w-full">
                                                    <InputBox
                                                        label={"Organization Name*"}
                                                        placeholder={"Enter Organization Name"}
                                                        id={"organization_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={orgDetails?.org_name}
                                                        handleOnChangeInput={handleOnChangeOrgDetails}
                                                        emptyField={
                                                            emptyField && orgDetails?.org_name.trim() === ""
                                                        }
                                                        usernameError={
                                                            toastErrorMessage ===
                                                            "Organization already exists. Please try another"
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="w-1/3 px-[18px] mb-6">
                                                <div className="w-full">
                                                    <PhoneNumberValidator
                                                        label={"Main Number*"}
                                                        placeholder={"Enter main number"}
                                                        id={"main_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={orgDetails?.main_number}
                                                        handleOnChangeInput={handleOnChangeOrgDetails}
                                                        isCode={true}
                                                        emptyField={
                                                            emptyField && orgDetails.main_number.trim() === ""
                                                        }
                                                        countryCodeList={phoneCodeArray}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        isPhoneNumberValid={isPhoneNumberValid.main_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        submitSelected={submitSelected}
                                                    //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="w-2/3 px-[18px] mb-6">
                                                <TextArea
                                                    label={"Address"}
                                                    htmlFor={"user_address"}
                                                    id={"address"}
                                                    value={orgDetails?.address}
                                                    placeholder={"Enter Address"}
                                                    // emptyField={false}
                                                    handleOnChangeInput={handleOnChangeOrgDetails}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-4 border border-[#C5C9DA] rounded py-[19px] pl-[9px] pr-5 flex justify-between items-center">
                                        <h1 className="text-xl font-normal text-[#000000]">
                                            Add Sub Division and Standard Values
                                        </h1>
                                    </div>
                                    {newSubDiv.map((subdiv, i) => (
                                        <div
                                            key={i}
                                            className="mt-8 border border-[#C5C9DA] px-[24px] py-3"
                                        >
                                            <div className="xl:w-[90%] w-[95%] relative">
                                                <div className="flex flex-wrap -mx-[18px]">
                                                    <div className="w-2/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Sub Division Name*"}
                                                                placeholder={"Enter Sub Division Name"}
                                                                id={"sub_div_name"}
                                                                htmlFor={"Admin_Username"}
                                                                value={newSubDiv[i]?.sub_div_name}
                                                                index={i}
                                                                emptyField={
                                                                    emptyField &&
                                                                    newSubDiv[i].sub_div_name.trim() === ""
                                                                }
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="xl:w-[90%] w-[95%]">
                                                <div className="flex flex-wrap -mx-[18px]">
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <DropdownWithSearch
                                                                label={"Corporate Users"}
                                                                id={`corporate_users`}
                                                                placeholder={
                                                                    dataArr.length === 0 || userArr[i]?.length < 1
                                                                        ? "Select Corporate Users"
                                                                        : `${userArr[i]?.length} Selected`
                                                                }
                                                                disabled={false}
                                                                index={i}
                                                                value={""}
                                                            // value={newOrgFields[index].organizations}
                                                            />
                                                        </div>

                                                        {/* new component for dropdown with search */}
                                                        {/* <div className="w-full">
                                                        <CorpOrgDropdownWithSearch
                                                            label={"Corporate Users"}
                                                            id={`corporate_users`}
                                                            placeholder={handlePlaceHolder('corporate')}
                                                            disabled={false}
                                                            value={''}
                                                            isSelectAllChecked={isSelectAllChecked}
                                                            setIsSelectAllChecked={setIsSelectAllChecked}
                                                            isObserver={true}
                                                            suggestions={suggestions}
                                                            setSuggestions={setSuggestions}
                                                            isSearchedSelectAllChecked={isSearchedSelectAllChecked}
                                                            setIsSearchedSelectAllChecked={setIsSearchedSelectAllChecked}
                                                        />
                                                    </div> */}
                                                    </div>
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <DropdownSearchForProvider
                                                                label={"Providers"}
                                                                id={`provider_users`}
                                                                placeholder={
                                                                    providerDataArr.length === 0 ||
                                                                        providerArr[i]?.length < 1
                                                                        ? "Select Providers"
                                                                        : `${providerArr[i]?.length} Selected`
                                                                }
                                                                disabled={false}
                                                                value={""}
                                                                index={i}
                                                            // value={newOrgFields[index].organizations}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <DropdownSearchForMonitor
                                                                label={"Monitor Users"}
                                                                id={`monitor_user`}
                                                                placeholder={
                                                                    monitorDataArr.length === 0 ||
                                                                        monitorArr[i]?.length < 1
                                                                        ? "Select Monitor Users"
                                                                        : `${monitorArr[i]?.length} Selected`
                                                                }
                                                                disabled={false}
                                                                index={i}
                                                                value={""}
                                                            // value={newOrgFields[index].organizations}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 className="text-lg font-normal text-[#000000] mb-5">
                                                    Wellness Information
                                                </h1>
                                                <div className="flex flex-wrap -mx-[18px]">
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Number of Minutes"}
                                                                placeholder={"Enter No.of minutes"}
                                                                id={"no_of_minutes"}
                                                                htmlFor={"no_of_minutes"}
                                                                isUnit={true}
                                                                unitType={"Minutes"}
                                                                value={newSubDiv[i]?.no_of_minutes}
                                                                emptyField={""}
                                                                sessionError={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Number of Time Periods"}
                                                                placeholder={"Enter No.of time periods"}
                                                                id={"no_of_time_period"}
                                                                htmlFor={"no_of_time_period"}
                                                                value={newSubDiv[i]?.no_of_time_period}
                                                                emptyField={""}
                                                                sessionError={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px]">
                                                        <div className="xl:w-[50%] w-[55%]">
                                                            <Dropdown
                                                                label={"Time Period"}
                                                                id={"time_period"}
                                                                placeholder={"Day(s)"}
                                                                value={newSubDiv[i]?.time_period}
                                                                options={[
                                                                    "Day(s)",
                                                                    "Week(s)",
                                                                    "Month(s)",
                                                                    "Calendar Month(s)",
                                                                ]}
                                                                emptyField={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 className="text-lg font-normal text-[#000000] mb-5">
                                                    Vital Collection Information
                                                </h1>
                                                <div className="flex flex-wrap -mx-[18px]">
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Number of Readings"}
                                                                placeholder={"Enter No.of readings"}
                                                                id={"no_of_readings"}
                                                                htmlFor={"no_of_readings"}
                                                                isUnit={true}
                                                                unitType={"Readings"}
                                                                value={newSubDiv[i]?.no_of_readings}
                                                                emptyField={""}
                                                                sessionError={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Number of Time Periods"}
                                                                placeholder={"Enter No.of time periods"}
                                                                id={"no_of_time_period2"}
                                                                htmlFor={"no_of_time_period"}
                                                                value={newSubDiv[i]?.no_of_time_period2}
                                                                emptyField={""}
                                                                sessionError={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px]">
                                                        <div className="xl:w-[50%] w-[55%]">
                                                            <Dropdown
                                                                label={"Time Period"}
                                                                id={"time_period2"}
                                                                placeholder={"Day(s)"}
                                                                value={newSubDiv[i]?.time_period2}
                                                                options={[
                                                                    "Day(s)",
                                                                    "Week(s)",
                                                                    "Month(s)",
                                                                    "Calendar Month(s)",
                                                                ]}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                                index={i}
                                                                emptyField={""}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <h1 className="text-lg font-normal text-[#000000] mb-5">
                                                    Point Of Contact{" "}
                                                </h1>
                                                <div className="flex flex-wrap -mx-[18px]">
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Name"}
                                                                placeholder={"Enter name"}
                                                                id={"name"}
                                                                htmlFor={"name"}
                                                                value={newSubDiv[i]?.name}
                                                                emptyField={""}
                                                                sessionError={""}
                                                                index={i}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                            {/* submitSelected&&pocError&&newSubDiv[i]?.name.trim()===''&&(newSubDiv[i].email_addr.trim()!==""||newSubDiv[i].main_number!==""||newSubDiv[i].mobile_number!=="") */}
                                                            {/* {pocError&&newSubDiv[i]?.name.trim()===''&&(newSubDiv[i].email_addr.trim()!==""||newSubDiv[i].main_number!==""||newSubDiv[i].mobile_number!=="") && <ErrorMessage error  message={"Name is a required field"}/>} */}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px] mb-5">
                                                        <div className="w-full">
                                                            <InputBox
                                                                label={"Email Address"}
                                                                placeholder={"Enter email address"}
                                                                id={"email_addr"}
                                                                htmlFor={"email_addr"}
                                                                value={newSubDiv[i]?.email_addr}
                                                                emptyField={""}
                                                                index={i}
                                                                emailError={
                                                                    emailError &&
                                                                    newSubDiv[i].email_addr.trim() !== "" &&
                                                                    validateEmail(newSubDiv[i].email_addr)
                                                                }
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                            />
                                                            {emailError &&
                                                                newSubDiv[i].email_addr.trim() !== "" &&
                                                                validateEmail(newSubDiv[i].email_addr) && (
                                                                    <ErrorMessage
                                                                        error
                                                                        message={"Invalid email address"}
                                                                    />
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px]">
                                                        <div className="w-full">
                                                            <PhoneNumberValidator
                                                                label={"Main Number"}
                                                                placeholder={"Enter Main Number"}
                                                                id={"poc_main_number"}
                                                                htmlFor={"Admin_Main_Number"}
                                                                value={newSubDiv[i]?.main_number}
                                                                emptyField={false}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                                isCode={true}
                                                                index={i}
                                                                countryCodeList={phoneCodeArray}
                                                                handleCOuntryCodeForObj={
                                                                    handleCOuntryCodeForObj
                                                                }
                                                                country_code={country_code}
                                                                countryCodeVal={
                                                                    newSubDivCountycodes[i]?.poc_main_number
                                                                }
                                                                setCountryCodeVal={setNewSubDivCountrycodes}
                                                                isPhoneNumberValid={
                                                                    newSubValidCountrycode[i]?.poc_main_number
                                                                }
                                                                setIsPhoneNumberValid={
                                                                    handlePhoneLayerValidation
                                                                }
                                                                submitSelected={submitSelected}
                                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="w-1/3 px-[18px]">
                                                        <div className="w-full">
                                                            <PhoneNumberValidator
                                                                label={"Mobile Number"}
                                                                placeholder={"Enter Mobile Number"}
                                                                id={"mobile_number"}
                                                                htmlFor={"Admin_Mobile_Number"}
                                                                value={newSubDiv[i]?.mobile_number}
                                                                emptyField={false}
                                                                handleOnChangeInput={
                                                                    handleOnChangeSubDivDetails
                                                                }
                                                                handleCOuntryCodeForObj={
                                                                    handleCOuntryCodeForObj
                                                                }
                                                                isCode={true}
                                                                index={i}
                                                                countryCodeList={phoneCodeArray}
                                                                country_code={country_code}
                                                                countryCodeVal={
                                                                    newSubDivCountycodes[i]?.mobile_number
                                                                }
                                                                isPhoneNumberValid={
                                                                    newSubValidCountrycode[i]?.mobile_number
                                                                }
                                                                setIsPhoneNumberValid={
                                                                    handlePhoneLayerValidation
                                                                }
                                                                setCountryCodeVal={setNewSubDivCountrycodes}
                                                                submitSelected={submitSelected}
                                                            //onPhoneNumberValidationChange={handlePhoneNumberValidationChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="flex items-center xl:justify-start justify-between flex-wrap mt-[24px] w-full">
                                        <div className="flex items-center">
                                            <p className="font-normal text-[#000000] xl:pl-1 pr-[30px]">
                                                Value Added
                                            </p>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input
                                                        id="value_added_true"
                                                        type="radio"
                                                        name="default-radio1"
                                                        checked={orgDetails?.value_added}
                                                        onChange={() =>
                                                            handleOnChangeOrgDetails("value_added", false)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="value_added_true"
                                                        className={`text-base font-normal ${orgDetails?.value_added
                                                            ? "text-[#000]"
                                                            : "text-[#52555D]"
                                                            } pl-8 w-full cursor-pointer`}
                                                    >
                                                        True
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input
                                                        id="value_added_false"
                                                        type="radio"
                                                        name="default-radio1"
                                                        checked={!orgDetails?.value_added}
                                                        onChange={() =>
                                                            handleOnChangeOrgDetails("value_added", true)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="value_added_false"
                                                        className={`text-base font-normal ${!orgDetails?.value_added
                                                            ? "text-[#000]"
                                                            : "text-[#52555D]"
                                                            } pl-8 w-full cursor-pointer`}
                                                    >
                                                        False
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex items-center">
                                            <p className="font-normal text-[#000000] 2xl:ml-20 xl:ml-14 pr-[30px]">
                                                Direct Billing
                                            </p>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input
                                                        id="direct_billing_true"
                                                        type="radio"
                                                        name="default-radio2"
                                                        checked={orgDetails?.direct_billing}
                                                        onChange={() =>
                                                            handleOnChangeOrgDetails("direct_billing", false)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="direct_billing_true"
                                                        className={`text-base font-normal ${orgDetails?.direct_billing
                                                            ? "text-[#000]"
                                                            : "text-[#52555D]"
                                                            } pl-8 w-full cursor-pointer`}
                                                    >
                                                        True
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="p-2">
                                                <div className="relative custom-radioBlue flex items-center">
                                                    <input
                                                        id="direct_billing_false"
                                                        type="radio"
                                                        name="default-radio"
                                                        checked={!orgDetails?.direct_billing}
                                                        onChange={() =>
                                                            handleOnChangeOrgDetails("direct_billing", true)
                                                        }
                                                    />
                                                    <label
                                                        htmlFor="direct_billing_false"
                                                        className={`text-base font-normal ${!orgDetails?.direct_billing
                                                            ? "text-[#000]"
                                                            : "text-[#52555D]"
                                                            } pl-8 w-full cursor-pointer`}
                                                    >
                                                        False
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-end pr-5">
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() =>
                                        !isDisableCancel
                                            ? setConfirmationStateCancel(true)
                                            : navigate("/manage-organizations", {
                                                state: location.state,
                                            })
                                    }
                                    // disabled={isDisableCancel}
                                    className={` px-4 py-2.5 mr-5 text-lg font-semibold  text-[#972E4C] border border-[#972E4C] rounded-[16px] mt-2.5 xl:w-[148px] w-[130px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}
                                >
                                    {"Cancel"}
                                </button>
                                <button
                                    type="button"
                                    id="update"
                                    // onClick={handleOnAddUser}
                                    disabled={loading}
                                    onClick={handleSubmit}
                                    className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}
                                >
                                    {"Submit"}
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </div>

                {/* } */}
                {(confirmationState || confirmationStateCancel) && (
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={
                                    confirmationState
                                        ? handleOnAddOrganization
                                        : () => {
                                            setIsDisableCancel(true),
                                                setConfirmationStateCancel(false),
                                                navigate("/manage-organizations", {
                                                    state: location.state,
                                                }
                                                );
                                        }
                                }
                                handleClose={
                                    confirmationState
                                        ? () => {
                                            setConfirmationState(false);
                                        }
                                        : () => {
                                            setConfirmationStateCancel(false);
                                        }
                                }
                                data-testid="confirm-btn"
                                disabled={loading}
                                tittle={
                                    confirmationStateCancel ? "Cancel" : `${"Add Organization"}`
                                }
                                message={
                                    confirmationState
                                        ? `Are you sure you want to add this organization?`
                                        : "Are you sure you want to cancel the changes?"
                                }
                                buttonName={
                                    true && !loading ? "Yes" : <span>{<Loader />}</span>
                                }
                                CancelButton={"No"}
                            />
                        }
                    />
                )}
                {helpGuideModel && helpguidestatus === "fulfilled" && (
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                )}
            </div>
        </>
    );
}
